import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { PaymentMethodsDialog as PaymentMethodsDialogComponent } from './PaymentMethodsDialog';

type PaymentMethodsDialogState = {
  translate: ReturnType<typeof getTranslate>;
};

export const mapStateToProps = (
  state: WebOrder.State,
): PaymentMethodsDialogState => {
  return {
    translate: getTranslate(state.locale),
  };
};

export const PaymentMethodsDialog = connect(mapStateToProps)(
  PaymentMethodsDialogComponent,
);
